export default __webpack_public_path__ + "static/media/pagbank.f99a9584.png";